module.exports = __webpack_public_path__ + "img/image76.22898ab.jpg";